<template>
	<div style="margin-bottom:30px;">
		<div class="container hidden-xs">
			<b-breadcrumbs :items="breadcrumbs"/>
		</div>
		<delete-modal
			:show-modal="showDeleteModal"
			:details="currentItem"
			@closeDeleteModal="hideDeleteModal"
			@delete="deleteItem"
		/>
		<edit-modal
			:show-modal="showEditModal"
			:details="currentItem"
			@closeEditModal="hideEditModal"
			@edit="editItem"
		/>
		<section class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-6">
					<h1>Tags</h1>
					<div class="page-summary-container">
						<div class="page-summary-text">
							Add, edit & delete tags
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<div class="input-group">
								<input
									v-model="tagSearchTerm"
									type="text"
									class="form-control"
									style="height:40.25px;"
									placeholder="Search tags"
									@keyup.enter="searchTags"
								>
								<span class="input-group-btn">
									<b-btn class="btn-primary" @click="searchTags">
										<i class="material-icons">search</i>
									</b-btn>
								</span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<div class="input-group">
								<input
									v-model="newTag"
									type="text"
									class="form-control"
									:class="{ 'error': $v.newTag.$error }"
									style="height:40.25px;"
									placeholder="Add new tag..."
									@keyup.enter="addTag"
								>
								<span class="input-group-btn">
									<b-btn class="btn-info" @click="addTag">
										<i class="material-icons">add</i>
									</b-btn>
								</span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<template v-if="loadingTags">
								<div class="container-fluid  loading-container">
									<img class="section-loader" src="@/assets/images/iadsa-section-loader-admin.gif"/>
								</div>
							</template>
							<template v-else-if="tags && tags.length > 0">
								<div
									v-for="tag in tags"
									:key="tag.id"
									class="list-container list-container-notifications"
								>
									<div class="row">
										<div class="col-xs-9">
											<span class="label label-gray">{{ tag.name }}</span>
										</div>
										<div class="col-xs-3">
											<b-dropdown class="btn-group pull-right" :menu-right="true">
												<b-btn class="btn btn-primary btn-sm dropdown-toggle">
													Actions
													<span class="form-label sr-only">Toggle Dropdown</span>
												</b-btn>
												<template slot="dropdown">
													<li>
														<a
															@click="showEditModal=true; setCurrentItem(tag, 'tag')"
															role="button"
														>Edit</a>
													</li>
													<li>
														<a
															@click="showDeleteModal=true; setCurrentItem(tag, 'tag')"
															role="button"
														>Delete</a>
													</li>
												</template>
											</b-dropdown>
										</div>
									</div>
								</div>
							</template>
							<template v-else>
								<h2>No tags found</h2>
							</template>
							<div class="row">
								<div class="col-xs-12">
									<div class="pagination-container">
										<b-pagination
											v-if="tagsPagination && tagsPagination.totalPages > 1"
											v-model="tagsPagination.page"
											:total-page="tagsPagination.totalPages"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-12 col-sm-6 pull-right">
					<h1>Regions</h1>
					<div class="page-summary-container">
						<div class="page-summary-text">
							Add, edit & delete regions
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<div class="input-group">
								<input
									v-model="regionSearchTerm"
									type="text"
									class="form-control"
									style="height:40.25px;"
									placeholder="Search regions"
									@keyup.enter="searchRegions"
								>
								<span class="input-group-btn">
									<b-btn class="btn-primary" @click="searchRegions">
										<i class="material-icons">search</i>
									</b-btn>
								</span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<div class="input-group">
								<input
									v-model="newRegion"
									type="text"
									class="form-control"
									:class="{ 'error': $v.newRegion.$error }"
									style="height:40.25px;"
									placeholder="Add new region..."
									@keyup.enter="addRegion"
								>
								<span class="input-group-btn">
									<b-btn class="btn-info" @click="addRegion">
										<i class="material-icons">add</i>
									</b-btn>
								</span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<template v-if="loadingRegions">
								<div class="container-fluid loading-container">
									<img class="section-loader" src="@/assets/images/iadsa-section-loader-admin.gif"/>
								</div>
							</template>
							<template v-else-if="regions && regions.length > 0">
								<div
									v-for="region in regions"
									:key="region.id"
									class="list-container list-container-notifications"
								>
									<div class="row">
										<div class="col-xs-9">
											<span class="label label-red">{{ region.name }}</span>
										</div>
										<div class="col-xs-3">
											<b-dropdown class="btn-group pull-right" :menu-right="true">
												<b-btn class="btn btn-primary btn-sm dropdown-toggle">
													Actions
													<span class="form-label sr-only">Toggle Dropdown</span>
												</b-btn>
												<template slot="dropdown">
													<li>
														<a
															@click="showEditModal=true; setCurrentItem(region, 'region')"
															role="button"
														>Edit</a>
													</li>
													<li>
														<a
															@click="showDeleteModal=true; setCurrentItem(region, 'region')"
															role="button"
														>Delete</a>
													</li>
												</template>
											</b-dropdown>
										</div>
									</div>
								</div>
							</template>
							<template v-else>
								<h2>No regions found</h2>
							</template>
							<div class="row">
								<div class="col-xs-12">
									<div class="pagination-container">
										<b-pagination
											v-if="regionPagination && regionPagination.totalPages > 1"
											v-model="regionPagination.page"
											:total-page="regionPagination.totalPages"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="less" scoped>
	.input-group {
		margin-bottom: 30px;
	}
	.error {
		border-color: red;
		color: red;
	}
	.loading-container {
		text-align: center;
	}
	.section-loader {
		max-width: 100px;
		height: auto;
	}
</style>

<script>
import deleteModal from '@/components/delete-modal';
import editModal from '@/components/edit-modal';
import { Notification } from 'uiv';
import { startCase } from 'lodash/fp';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import { determineNextPageOnDelete } from '@/modules/utils';

export default {
	components: { deleteModal, editModal },
	created() {
		this.getTags({ pageSize: 10 });
		this.getRegions({ pageSize: 10 });
	},
	data() {
		return {
			tagSearchTerm: null,
			tags: null,
			tagsPagination: null,
			newTag: null,
			regionSearchTerm: null,
			regions: null,
			regionPagination: null,
			newRegion: null,
			showDeleteModal: false,
			showEditModal: false,
			currentItem: {
				id: null,
				name: null,
				type: null
			},
			options: null,
			loadingTags: false,
			loadingRegions: false
		};
	},
	validations: {
		newTag: { required },
		newRegion: { required }
	},
	computed: {
		...mapGetters({ getBreadcrumbs: 'breadcrumbs' }),
		breadcrumbs() {
			return this.getBreadcrumbs;
		}
	},
	methods: {
		setCurrentItem(data, type) {
			this.currentItem.id = data.id;
			this.currentItem.name = data.name;
			this.currentItem.type = type;
		},
		hideDeleteModal() {
			this.showDeleteModal = false;
		},
		hideEditModal() {
			this.showEditModal = false;
		},
		async searchTags() {
			await this.getTags({ searchTerm: this.tagSearchTerm, page: 1 });
		},
		async searchRegions() {
			await this.getRegions({ searchTerm: this.regionSearchTerm, page: 1 });
		},
		async getTags(params) {
			this.loadingTags = true;
			const { data: { data: tags, pagination } } = await this.$axios.get('/tag', { params });
			this.$set(this, 'tags', tags);
			this.$set(this, 'tagsPagination', pagination);
			this.loadingTags = false;
		},
		async getRegions(params) {
			this.loadingRegions = true;
			const { data: { data: regions, pagination } } = await this.$axios.get('/region', { params });
			this.$set(this, 'regions', regions);
			this.$set(this, 'regionPagination', pagination);
			this.loadingRegions = false;
		},
		async deleteItem(id) {
			await this.$axios.delete(`/${this.currentItem.type}/${id}`);
			// if this is the last item in a page, render the previous page; current page limit is 10
			let tagPage = null;
			let regionPage = null;
			if (this.currentItem.type === 'tag') {
				tagPage = determineNextPageOnDelete(this.tagsPagination, 10);
			} else if (this.currentItem.type === 'region') {
				regionPage = determineNextPageOnDelete(this.regionPagination, 10);
			}

			this.getTags({
				searchTerm: this.tagSearchTerm,
				page: tagPage || this.tagsPagination.page
			});
			this.getRegions({
				searchTerm: this.regionSearchTerm,
				page: regionPage || this.regionPagination.page
			});

			this.hideDeleteModal();
			Notification.notify({
				type: 'danger',
				title: `${startCase(this.currentItem.type)} deleted`,
				content: `Successfully deleted ${this.currentItem.name}.`,
				duration: 10000
			});
		},
		async addRegion() {
			if (this.$v.newRegion.$invalid) {
				this.$v.newRegion.$touch();
			} else {
				try {
					await this.$axios.post('/region', { name: this.newRegion });
					Notification.notify({
						type: 'success',
						title: `${this.newRegion} region created successfully.`,
						duration: 10000
					});
					await this.getRegions({
						searchTerm: this.regionSearchTerm,
						page: this.regionPagination.page
					});
					this.newRegion = null;
				} catch (e) {
					Notification.notify({
						type: 'danger',
						title: 'Could not create region.',
						content: e.response ? e.response.data.message : '',
						duration: 10000
					});
				}
			}
		},
		async addTag() {
			if (this.$v.newTag.$invalid) {
				this.$v.newTag.$touch();
			} else {
				try {
					await this.$axios.post('/tag', { name: this.newTag });
					Notification.notify({
						type: 'success',
						title: `${this.newTag} tag created successfully.`,
						duration: 10000
					});
					await this.getTags({
						searchTerm: this.tagSearchTerm,
						page: this.tagsPagination.page
					});
					this.newTag = null;
				} catch (e) {
					Notification.notify({
						type: 'danger',
						title: 'Could not create tag.',
						content: e.response ? e.response.data.message : '',
						duration: 10000
					});
				}
			}
		},
		async editItem(id, newValue) {
			try {
				await this.$axios.put(`/${this.currentItem.type}/${id}`, { name: newValue.value });
				await this.getTags({
					searchTerm: this.tagSearchTerm,
					page: this.tagsPagination.page
				});
				await this.getRegions({
					searchTerm: this.regionSearchTerm,
					page: this.regionPagination.page
				});
				Notification.notify({
					type: 'success',
					title: `${this.currentItem.name} changed to ${newValue.value}.`,
					duration: 10000
				});
				this.hideEditModal();
			} catch (e) {
				Notification.notify({
					type: 'danger',
					title: `Could not edit ${this.currentItem.name}.`,
					content: e.response ? e.response.data.message : '',
					duration: 10000
				});
			}
		}
	},
	watch: {
		'regionPagination.page': async function regionPageWatcher() {
			await this.getRegions({
				searchTerm: this.regionSearchTerm,
				page: this.regionPagination.page,
				pageSize: 10
			});
		},
		'tagsPagination.page': async function tagPageWatcher() {
			await this.getTags({
				searchTerm: this.tagSearchTerm,
				page: this.tagsPagination.page,
				pageSize: 10
			});
		}
	},
};
</script>
